// extracted by mini-css-extract-plugin
module.exports = {"primary":"#008aff","primaryLight":"#7daee3","secondary":"#18327f"};